import { useSearchParams } from "react-router-dom";
import { PageContainer } from "@/layouts/PageContainer";
import { Avatar } from "@/components/ui/Avatar";
import { Badge } from "@/components/ui/Badge";
import { Button } from "@/components/ui/Button";
import { SegmentedControl } from "@/components/ui/SegmentedControl";
import { useAuthUser, useLogout } from "@/features/auth/useAuth";
import AppVersions from "./appVersions/AppVersions";

type SettingsTab = "account" | "app-versions";

export default function Settings() {
  const { user } = useAuthUser();
  const logout = useLogout();
  const [params, setParams] = useSearchParams();
  const tab: SettingsTab = params.get("tab") === "app-versions" ? "app-versions" : "account";

  return (
    <PageContainer
      title="Settings"
      description={tab === "account" ? "Your admin account." : "Control which app versions riders and drivers can use."}
      actions={
        <SegmentedControl<SettingsTab>
          size="md"
          options={[
            { value: "account", label: "Account" },
            { value: "app-versions", label: "App versions" },
          ]}
          value={tab}
          onChange={(next) => setParams(next === "account" ? {} : { tab: next }, { replace: true })}
        />
      }
    >
      {tab === "app-versions" ? (
        <AppVersions />
      ) : (
        <>
          <div className="card flex max-w-xl items-center justify-between p-5">
            <div className="flex items-center gap-3">
              <Avatar name={user?.name ?? "Admin"} size={44} />
              <div>
                <p className="font-semibold text-ink">{user?.name}</p>
                <p className="text-sm text-ink-faint">{user?.email}</p>
                <div className="mt-1 flex gap-1">
                  {user && <Badge tone="teal">{user.role}</Badge>}
                </div>
              </div>
            </div>
            <Button variant="outline" onClick={() => logout.mutate()} loading={logout.isPending}>
              Log out
            </Button>
          </div>

          <p className="max-w-xl text-xs text-ink-faint">
            Notification preferences, team management, and audit-log export will appear here once
            the corresponding admin-service endpoints are available.
          </p>
        </>
      )}
    </PageContainer>
  );
}
